<template>
  <div>
    <div
      v-if="spare_part_request || spare_part_request != null"
      class="md-layout"
    >
      <md-toolbar class="md-dense color" style="width:100%">
        <!-- <div style="width:50%">
          <h3 class="md-title" style="flex:1;">
            <p
              v-if="spare_part_request.spare_part_request_status == 0"
              style="text-align: left; font-weight:bold;"
            >
              REGISTERED
            </p>
            <p
              v-if="spare_part_request.spare_part_request_status == 1"
              style="text-align: left; font-weight:bold;"
            >
              REQUEST APPROVAL
            </p>
            <p
              v-if="spare_part_request.spare_part_request_status == 2"
              style="text-align: left; font-weight:bold;"
            >
              REJECTED
            </p>
            <p
              v-if="spare_part_request.spare_part_request_status == 3"
              style="text-align: left; font-weight:bold;"
            >
              APPROVED
            </p>
            <p
              v-if="spare_part_request.spare_part_request_status == 4"
              style="text-align: left; font-weight:bold;"
            >
              DELIVERED
            </p>
            <p
              v-if="spare_part_request.spare_part_request_status == 5"
              style="text-align: left; font-weight:bold;"
            >
              ITEM RECEIVED
            </p>
          </h3>
        </div> -->
        <div style="width:50%; ">
          <div class="md-toolbar-section-end">
            <!-- <md-dialog :md-active.sync="active" v-bind:md-fullscreen="false">
              <md-dialog-title>
                History Status
                <md-button
                  style="float:right;"
                  class="md-dense md-round md-icon-button"
                  @click="active = false"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-dialog-title>
              <md-card class="md-content1 md-scrollbar">
                <md-card-content>
                  <md-table>
                    <md-table-row>
                      <md-table-head><b>Change</b></md-table-head>
                      <md-table-head><b>By</b></md-table-head>
                      <md-table-head><b>Action</b></md-table-head>
                      <md-table-head><b>Status</b></md-table-head>
                    </md-table-row>
                    <md-table-row
                      v-for="(item,
                      index) in spare_part_request.spare_part_request_history_status"
                      :key="index"
                    >
                      <md-table-cell>{{ $moment(item.updated_at).utc().format('DD-MM-YYYY HH:mm') }}</md-table-cell>
                      <md-table-cell>{{ item.name_by }}</md-table-cell>
                      <md-table-cell>
                        <span v-if="item.status_action == 1"
                          >Request Approval</span
                        >
                        <span v-if="item.status_action == 2">Reject</span>
                        <span v-if="item.status_action == 3">Approve</span>
                        <span v-if="item.status_action == 4">Deliver</span>
                        <span v-if="item.status_action == 5"
                          >Item Received</span
                        >
                      </md-table-cell>
                      <md-table-cell>
                        <span v-if="item.status == 0">Registered</span>
                        <span v-if="item.status == 1">Request Approval</span>
                        <span v-if="item.status == 2">Rejected</span>
                        <span v-if="item.status == 3">Approved</span>
                        <span v-if="item.status == 4">Delivered</span>
                        <span v-if="item.status == 5">Item Received</span>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </md-dialog>
            <md-button class="nonprint; color md-dense" @click="active = true"
              >History Status</md-button
            >
            <md-menu md-direction="bottom-start">
              <md-button
                v-if="spare_part_request.spare_part_request_status != 5"
                class="nonprint; md-dense color"
                md-menu-trigger
                >Change Status</md-button
              >
              <md-menu-content>
                <md-menu-item
                  v-if="
                    spare_part_request.spare_part_request_status == 0 &&
                      role.requester
                  "
                  class="noprint"
                  @click="updateStatusConfirmation(1, 'Request Approval')"
                  >Request Approval</md-menu-item
                >
                <md-menu-item
                  v-if="
                    spare_part_request.spare_part_request_status == 1 &&
                      role.approver
                  "
                  class="noprint"
                  @click="updateStatusConfirmation(3, 'Approve')"
                  >Approve</md-menu-item
                >
                <md-menu-item
                  v-if="
                    spare_part_request.spare_part_request_status == 1 &&
                      role.approver
                  "
                  class="noprint"
                  @click="updateStatusConfirmation(2, 'Reject')"
                  >Reject</md-menu-item
                >
                <md-menu-item
                  v-if="
                    spare_part_request.spare_part_request_status == 3 &&
                      role.requester
                  "
                  class="noprint"
                  @click="updateStatusConfirmation(4, 'Deliver')"
                  >Deliver</md-menu-item
                >
                <md-menu-item
                  v-if="
                    spare_part_request.spare_part_request_status == 4 &&
                      role.requester
                  "
                  class="noprint"
                  @click="updateStatusConfirmation(5, 'Item Receive')"
                  >Item Receive</md-menu-item
                >
                <md-menu-item
                  v-if="
                    spare_part_request.spare_part_request_status == 5 &&
                      (check_object_value(division, 'name', ['Admin']) ||
                        check_object_value(division, 'division_id', [8]))
                  "
                  class="noprint"
                  @click="updateStatusConfirmation(6, 'Payment Done')"
                  >Payment Done</md-menu-item
                >
                <md-menu-item
                  v-if="
                    spare_part_request.spare_part_request_status == 6 &&
                      (check_object_value(division, 'name', ['Admin']) ||
                        check_object_value(division, 'name', ['Auto Manager']))
                  "
                  class="noprint"
                  @click="updateStatusConfirmation(7, 'Item Received')"
                  >Item Received</md-menu-item
                >
               
              </md-menu-content>
            </md-menu> -->
            <md-button
              class="nonprint; color md-icon-button md-dense"
              @click="closeDetail()"
              ><md-icon>close</md-icon></md-button
            >
          </div>
        </div>
      </md-toolbar>

      <div
        class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100"
      >
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Item Info</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <table style="width:150mm;">
              <colgroup>
                <col style="width: 24mm" />
                <col style="width: 3mm" />
                <col style="width: 123mm" />
              </colgroup>
              <tr>
                <td style=" font-size: 15px;"><b>Warehouse</b></td>
                <td style="font-size: 15px;">:</td>
                <td style="font-size: 15px;">
                  <span v-if="spare_part_request.spare_part_request_warehouse">
                  {{spare_part_request.spare_part_request_warehouse.warehouse_name}}
                  </span>
                </td>
              </tr>
              <!-- <tr>
                <td style=" font-size: 15px;"><b>To</b></td>
                <td style="font-size: 15px;">:</td>
                <td style="font-size: 15px;">
                  {{
                    spare_part_request.spare_part_request_warehouse_to
                      .warehouse_name
                  }}
                </td>
              </tr> -->
              <tr>
                <td style=" font-size: 15px;"><b>Remark</b></td>
                <td style="font-size: 15px;">:</td>
                <td style="font-size: 15px;">
                  {{ spare_part_request.spare_part_request_remark }}
                </td>
              </tr>
            </table>

            <br />
            <md-divider></md-divider>
            <md-table>
              <md-table-row>
                <md-table-head><b>No.</b></md-table-head>
                <md-table-head><b>Item Name</b></md-table-head>
                <md-table-head><b>Qty</b></md-table-head>
                <md-table-head><b>Remark</b></md-table-head>
              </md-table-row>
              <md-table-row
                v-if="spare_part_request.spare_part_request_item.length == 0"
              >
                <md-table-cell colspan="8" class="nodata"
                  >No Data Available</md-table-cell
                >
              </md-table-row>
              <md-table-row
                v-else
                v-for="(item,
                index) in spare_part_request.spare_part_request_item"
                :key="index"
              >
                <md-table-cell>{{ index + 1 }}</md-table-cell>
                <md-table-cell>
                  <!-- {{
                    item.spare_part_request.spare_part_master_name +
                      "" +
                      item.spare_part_request.spare_part_master_code
                  }} -->

                  {{
                    item.spare_part.spare_part_master_name +
                      " " +
                      `(${item.spare_part.spare_part_master_code})`
                  }}
                </md-table-cell>
                <md-table-cell>
                  {{ parseFloat(item.spare_part_request_item_qty) }}
                </md-table-cell>
                <md-table-cell>
                  {{ item.spare_part_request_item_remark }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      <div v-bind:style="{ display: not_found }">
        <center v-if="spare_part_request == null">
          <h1>Not Found!</h1>
          <p>
            <a href="" @click="backToList()">Back To List?</a>
          </p>
        </center>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from "@/mixins/form-mixin";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
// import { Modal } from "@/components";
import Swal from "sweetalert2";
import vuetify from "@/plugins/vuetify";
// import { NavTabsCard,Tabs } from "@/components";

import Vue from "vue";

export default {
  name: "detail-spare-part-request",

  vuetify,

  components: {},
  props: {
    data_id: null,
  },

  mixins: [formMixin],

  data: () => ({
    spare_part_request: null,
    not_found: "none",
    active: false,
    // spare_part_master: null,
  }),

  async mounted() {
    // this.onMounted()
    // this.getListSpj();
    this.mounted = false;
  },

  async created() {
    this.me = await this.$store.getters["profile/me"];
    this.role = await this.$store.getters["role_permission/route_filter"];
    this.getSparePartRequestData();
    // console.log(this.id);
  },

  methods: {
    //fungsi yang berjalan saat page pertamakali dibuka
    async getSparePartRequestData() {
      //ambil list role permission user
      this.role = await this.$store.getters["role_permission/route_filter"];
      var me = await this.$store.getters["profile/me"];
      this.role_name = me.role_name;
      // console.log(this.role)

      //ambil data se sesuai dengan id yang ikut juga dikirim melalui route
      await this.$store.dispatch(
        "workshop_spare_part_request/get",
        this.data_id.id
      );
      this.spare_part_request = await this.$store.getters[
        "workshop_spare_part_request/spare_part_request"
      ];
      if (!this.spare_part_request) {
        this.not_found = "block";
        return;
      }

      // await this.$store.dispatch(
      //   "workshop_spare_part_master/get",
      //   this.data_id.id
      // );
      // this.spare_part_master = await this.$store.getters[
      //   "workshop_spare_part_master/spare_part_master"
      // ];

      console.log(this.spare_part_request);
    },

    async closeDetail() {
      this.$parent.$parent.modalCloseDetailRequest();
    },

    // fungsi currency number
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    // direct ke list view table
    backToList() {
      //kembali ke list
      this.$router.replace({ name: "List Spare Part Transfer" });
    },

    updateStatusConfirmation(status, status_text) {
      Swal.fire({
        title: "Are you sure want to change the status to " + status_text + "?",
        text: "The data will Saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.changeStatus(status);
        }
      });
    },

    async changeStatus(status) {
      const data = {
        type: "workshop_spare_part_requests",
        id: this.spare_part_request.id,
        status: status,
      };
      try {
        await this.$store.dispatch("workshop_spare_part_request/update", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully changed status."
        );
        // var indexOption = this.table.findIndex(p => p.id ==  id)
        // this.table[indexOption].spare_part_request_status = status
        this.getSparePartRequestData();
        // this.modalCloseFormPrice()
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong"
        );
        console.log(e);
      }
    },

    // check_object_value(array, key, value) {
    //     //return array.some(object => object[key] === value);
    //     return array.some(object => value.includes(object[key]));
    //     },
  },
};
</script>
<style lang="scss" scoped>
.title-name {
  background-color: powderblue;
}
table {
  width: 100%;
  table-layout: fixed;
}
.table-kotak {
  border-collapse: collapse;
}
table.table-kotak td {
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th {
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print {
  visibility: hidden;
}
@media print {
  .print {
    visibility: visible;
  }
  .noprint {
    display: none;
  }
}
.photo_list {
  max-width: 50%;
  height: auto;
  display: block;
  /* margin-left: auto;
    margin-right: auto; */
}

.nodata {
  color: #aaa;
  text-align: center;
}

.md-card {
  box-shadow: 0 3px 5px 1px rgb(0 0 0/ 14%);
}

.md-toolbar {
  position: relative;
  z-index: 0;
}

.md-content1 {
  max-width: 800px;
  max-height: 500px;
  overflow: auto;
}

.color {
  background-color: #1976d2 !important;
}

.coba {
  width: 800px !important;
  height: 610px !important;
  // margin: 50px auto !important;
  // top: auto !important;
  // bottom: auto !important;

  @media screen and (max-width: 992px) {
    width: 90% !important;
  }
}
</style>
